if (menuButtons.length > 0) {
  attachEvent('.menu__button', 'click', (btn) => {
    const isScrolled = document.body.classList.contains('is-scrolled');
    const parent = btn.target.closest('.menu__buttons-item');
    const isActive = parent.classList.contains('is-active');

    clearActiveMenu();

    if (!isActive) {
      parent.classList.add('is-active');
      return;
    }

    if (!homepageHeader || isScrolled) return;

    firstMenuButton.classList.add('is-active');
  });

  attachEvent('[data-close-menu]', 'click', clearActiveMenu);

  onKeydown('escape', clearActiveMenu);
}
